import { isAllowedAudioEmbedSrc } from "../../../../utils/urlValidation";

export const convertEmbedCodeToReact = (embedCode, setUrl) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(embedCode, "text/html");
  const elements = doc.body.children;

  const convertInlineStylesToReact = (inlineStyle) => {
    const styleObject = {};
    inlineStyle.split(";").forEach((declaration) => {
      if (!declaration.trim()) return;

      const [property, value] = declaration.split(":");
      if (property && value) {
        const camelCaseProperty = property
          .trim()
          .replace(/-([a-z])/g, (_, char) => char.toUpperCase());
        styleObject[camelCaseProperty] = value.trim();
      }
    });
    return styleObject;
  };

  // Security (nemesis #142): the pasted embed markup is stored and later rendered
  // on PUBLIC viewer pages. Only render an <iframe> whose src is an allow-listed
  // audio-embed host (Spotify / SoundCloud); ANY other iframe src — including
  // javascript:/data: and arbitrary third-party hosts — is dropped so raw markup
  // cannot smuggle an executable/hostile frame. Non-iframe nodes are dropped too:
  // they only ever rendered as escaped text (never useful markup) and dropping
  // them removes the last uncontrolled sink.
  return Array.from(elements)
    .map((el, index) => {
      if (el.tagName.toLowerCase() !== "iframe") return null;
      const src = el.getAttribute("src");
      if (!isAllowedAudioEmbedSrc(src)) return null;
      setUrl(src);
      return (
        <iframe
          key={index}
          title="Audio embed"
          src={src}
          width={"100%"}
          height={el.getAttribute("height")}
          scrolling={el.getAttribute("scrolling")}
          frameBorder={el.getAttribute("frameborder")}
          allow={el.getAttribute("allow")}
        />
      );
    })
    .filter(Boolean);
};

export const fetchSpotifyDetails = async (spotifyUrl) => {
  const canonicalUrl = spotifyUrl.replace("/embed/", "/");

  const response = await fetch(
    `https://open.spotify.com/oembed?url=${encodeURIComponent(canonicalUrl)}`
  );

  if (!response.ok) {
    throw new Error("Failed to fetch Spotify details");
  }

  const details = await response.json();

  return {
    title: details.title || "",
    image: details.thumbnail_url || null,
  };
};

export const extractSoundCloudTitle = (htmlString) => {
  // Parse the HTML string
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");

  // Find the div and the <a> elements
  const div = doc.querySelector("div");
  const artistAnchor = div.querySelector("a:nth-child(1)");
  const trackAnchor = div.querySelector("a:nth-child(2)");

  if (artistAnchor && trackAnchor) {
    const artist = artistAnchor.title; // Extract artist title
    const track = trackAnchor.title; // Extract track title
    return `${artist} - ${track}`;
  }

  return "Title not found";
};
